import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Container } from 'components/ui/Container';
import SidebarPopup, { SidebarPopupSide } from 'components/ui/popups/SidebarPopup';
import { useOpenStore } from 'hooks/useOpenStore';
import { accessibilityParamsStore } from 'stores/root';

import AccessibilityButton from './AccessibilityButton';
import LinkButtons from './LinkButtons';
import Logo from './Logo';
import MenuButton from './MenuButton';
import User from './User';

import s from './Header.module.scss';

const SidebarLoader = () => import('./SideMenu');

const Header: React.FC = () => {
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;
  const { isOpen, open, close } = useOpenStore();

  return (
    <Container className={cn(s.root, isAccessibilityMode && s.root_accessibility)} element="header">
      <div className={cn(s.root__flex, s.root__flex_start)}>
        <MenuButton onClick={open} />
        <Logo className={s.root__logo} />
      </div>
      <div className={cn(s.root__flex, s.root__right)}>
        <div className={s.root__buttons}>
          <LinkButtons />
          <AccessibilityButton className={s['root__accessibility-button']} />
        </div>
        <User className={s.root__user} />
      </div>
      <SidebarPopup
        withHeader={false}
        mobileFullscreen
        view="secondary"
        side={SidebarPopupSide.left}
        open={isOpen}
        onClose={close}
        contentLoader={SidebarLoader}
        classNameContainer={s['popup-container']}
      />
    </Container>
  );
};

export default observer(Header);
